<ng-container>
  <app-navbar></app-navbar>
</ng-container>

<div class="admin-hostings-page p-6">
  <!-- Tarjetas de estadísticas -->
  <div class="stats-grid mb-8">
    <div class="stat-card" *ngFor="let stat of stats">
      <div class="stat-header">
        <span>{{ stat.label }}</span>
        <mat-icon>{{ stat.icon }}</mat-icon>
      </div>
      <div class="stat-value">{{ stat.value }}</div>
      <div class="stat-sub">{{ stat.sub }}</div>
    </div>
  </div>

  <!-- Header de la sección -->
  <div class="hostings-header flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
    <div>
      <h2 class="text-xl font-semibold text-gray-900">Mis Reservas</h2>
      <p class="text-sm text-gray-500">Gestiona y administra tus reservas</p>
    </div>

    <div class="flex items-center gap-3 mt-3 sm:mt-0">
      <input type="text" placeholder="Buscar por alojamiento, habitación, email o ID de reserva..." class="search-input"
        [(ngModel)]="searchTerm" (input)="onSearch()" />

      <button mat-flat-button color="primary" class="btn-new flex items-center justify-center"
        (click)="openCreateModal()">
        <mat-icon fontIcon="add"></mat-icon>
        <span class="hidden sm:inline">Nueva Reserva</span>
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="is_loading" class="loading-container">
    <div class="spinner"></div>
    <p>Cargando reservas...</p>
  </div>

  <!-- Error Message -->
  <div *ngIf="error_msg" class="error-message">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error_msg }}</span>
  </div>

  <!-- Empty State -->
  <div *ngIf="!is_loading && reservations.length === 0 && !error_msg" class="empty-state">
    <mat-icon>event_busy</mat-icon>
    <h3>No hay reservas registradas</h3>
    <p>Comienza agregando tu primera reserva</p>
    <button mat-flat-button color="primary" class="btn-new" (click)="openCreateModal()">
      <span>Agregar Reserva</span>
    </button>
  </div>

  <!-- Tabla de Reservas -->
  <div *ngIf="!is_loading && paginatedReservas.length > 0" class="table-container">
    <div class="table-wrapper">
      <table class="reservas-table">
        <thead>
          <tr>
            <th class="th-alojamiento">Alojamiento</th>
            <th class="th-habitacion">Habitación</th>
            <th class="th-cliente">Cliente</th>
            <th class="th-checkin">Check-in</th>
            <th class="th-checkout">Check-out</th>
            <th class="th-huespedes">Huéspedes</th>
            <th class="th-total">Total</th>
            <th class="th-estado">Estado</th>
            <th class="th-acciones">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let reservation of paginatedReservas" class="table-row">
            <td class="td-alojamiento">
              <div class="alojamiento-cell">
                <mat-icon class="location-icon">location_on</mat-icon>
                <span class="alojamiento-name">{{ reservation.accommodation.name }}</span>
              </div>
            </td>
            <td class="td-habitacion">
              <div class="habitacion-cell">
                <span class="habitacion-tipo">{{ reservation.habitacion }}</span>
                <span class="habitacion-categoria">{{ reservation.room.number }} - {{ reservation.room.type }} </span>
              </div>
            </td>
            <td class="td-cliente">
              <div class="cliente-cell">
                <span class="cliente-nombre">{{ reservation.client.name }}</span>
                <span class="cliente-email">{{ reservation.client.email }}</span>
              </div>
            </td>
            <td class="td-checkin">
              <div class="date-cell">
                <mat-icon class="date-icon">event</mat-icon>
                <span>{{ formatDate(reservation.check_in) }}</span>
              </div>
            </td>
            <td class="td-checkout">
              <div class="date-cell">
                <mat-icon class="date-icon">event</mat-icon>
                <span>{{ formatDate(reservation.check_out) }}</span>
              </div>
            </td>
            <td class="td-huespedes">
              <div class="huespedes-cell" (click)="viewGuests(reservation.guests_detail)">
                <mat-icon class="huespedes-icon">group</mat-icon>
                <span>Ver ({{ reservation.guests_detail.length }})</span>
              </div>
            </td>
            <td class="td-total">
              <span class="total-amount">{{ formatCurrency(reservation.payment.total_value) }}</span>
            </td>
            <td class="td-estado">
              <span class="estado-badge" [ngClass]="{'bg-green-500': reservation.status === 'confirmado',
                                                        'bg-yellow-500': reservation.status === 'pendiente',
                                                        'bg-red-500': reservation.status === 'cancelado'}">
                {{ reservation.status }}
              </span>
            </td>
            <td class="td-acciones">
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Opciones de reserva" class="action-menu-button">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">

                <button mat-menu-item (click)="openReservationDetails(reservation)">
                  <mat-icon>visibility</mat-icon>
                  <span>Ver detalles</span>
                </button>

                <button mat-menu-item (click)="editReservation(reservation)">
                  <mat-icon>edit</mat-icon>
                  <span>Editar</span>
                </button>

                
                <!-- <button mat-menu-item (click)="cancelReserva(reserva)">
                  <mat-icon>cancel</mat-icon>
                  <span>Cancelar</span>
                </button> -->
                <button mat-menu-item (click)="deleteReserva(reservation)" class="delete-option">
                  <mat-icon>delete</mat-icon>
                  <span>Eliminar</span>
                </button>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Paginador personalizado -->
  <div class="pagination-container" *ngIf="!is_loading && paginatedReservas.length > 0">
    <div class="pagination-info">
      <span class="text-sm text-gray-600">
        Mostrando {{ (current_page * page_size) + 1 }} -
        {{ Math.min((current_page + 1) * page_size, paginatedReservas.length) }}
        de {{ paginatedReservas.length }} reservas
      </span>
    </div>

    <div class="pagination-controls">
      <!-- Selector de cantidad por página -->
      <mat-form-field appearance="outline" class="page-size-selector">
        <mat-label>Por página</mat-label>
        <mat-select [value]="page_size" (selectionChange)="onPageSizeChange($event.value)">
          <mat-option *ngFor="let size of page_size_options" [value]="size">
            {{ size }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Navegación de páginas -->
      <div class="page-navigation">
        <button mat-icon-button [disabled]="current_page === 0" (click)="onPageChange(current_page - 1)"
          class="nav-button">
          <mat-icon>chevron_left</mat-icon>
        </button>

        <div class="page-numbers">
          <button *ngFor="let page of [].constructor(totalPages); let i = index" mat-button
            [class.active]="i === current_page" (click)="onPageChange(i)" class="page-number">
            {{ i + 1 }}
          </button>
        </div>

        <button mat-icon-button [disabled]="current_page === totalPages - 1" (click)="onPageChange(current_page + 1)"
          class="nav-button">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>